module.exports = __webpack_public_path__ + "b09d4b560deed9fabf6edc47606c3202.png";